import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { RouteAction } from '@core/action/action';
import { CustomValidators } from '@core/custom-validators/validators';
import { TipoContato, TipoContatoEnum } from '@core/models/entidade';
import { CEPService } from '@core/services/cep.service';
import { CidadeService } from '@core/services/cidade.service';
import { MessageService } from '@core/services/message.service';
import { PaisService } from '@core/services/pais.service';
import { PessoaService } from '@core/services/pessoa.service';
import { TipoContatoService } from '@core/services/tipocontato.service';
import { UFService } from '@core/services/uf.service';
import { EntidadeSharedDataService } from '@modules/entidade/entidade-shared-data.service';
import { forkJoin, of } from 'rxjs';

@Component({
  selector: 'app-contato-form',
  templateUrl: './contato-form.component.html',
  styleUrls: ['./contato-form.component.scss']
})
export class ContatoFormComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() contato: any;
  @Input() dataSet: any;
  @Input() paginaEntidade: boolean = false;
  @Input() paginaVinculo: boolean = false;
  @Input() paginaPessoa: boolean = false;
  @Input() somenteVisualizar!: any;
  @Output() contatoEmit = new EventEmitter<any>();

  contatoForm!: FormGroup;
  contatoEditado: any;
  contatos: any[] = [];
  cidadeList: any[] = [];
  tipoContatoList: any[] = [];
  paisesList: any[] = [];
  ufList: any[] = [];
  ddiList: any[] = [];
  nomePessoaList: any[] = [];
  bairrosList: any[] = [];
  showPessoaDelegada = false;
  nzFilterOption = (): boolean => true;


  cep: string = '';
  tipoContatoSelecionada: any;
  // searchControl = new FormControl();
  acao!: RouteAction;
  inserir!: boolean;
  editar!: boolean;
  visualizar!: boolean;
  defaultPais: any;
  tipoContatoEnum = TipoContatoEnum;
  existeEndereco: boolean = false;
  cepToZipCode: boolean = false;

  constructor(
    private fb: FormBuilder,
    private ufService: UFService,
    private paisService: PaisService,
    private tipoContatoService: TipoContatoService,
    private route: ActivatedRoute,
    private cepService: CEPService,
    private messageService: MessageService,
    private cidadeService: CidadeService,
    private pessoaService: PessoaService,
    private entidadeSharedDataService: EntidadeSharedDataService
  ) { }

  ngAfterViewInit(): void {
    this.entidadeSharedDataService?.updateEmpresaEstrangeira$.subscribe(res => {
      if (res) {
        this.cepToZipCode = true;
      } else {
        this.cepToZipCode = false;
      }
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    const contatoParaEditar = Array.isArray(this.contato)
      ? this.contato.find((item: any) => item?.flagPrincipal) ?? this.contato[0]
      : this.contato;

    if (contatoParaEditar) {
      this.inserir = false;
      this.contatoForm?.patchValue(contatoParaEditar);
    } else {
      this.inserir = true;
    }

    if (this.dataSet?.length) {
      this.existeEndereco = this.dataSet.some((item: any) => item.tipoContato?.id === TipoContatoEnum.ENDERECO);
    }
  }

  ngOnInit() {
    this.carregarListas();
    this.construirForm();
    this.carregarPais();

    this.enderecoUf?.valueChanges.subscribe((val: any) => {
      if (val?.id) {
        this.cidadeService.getCidadesByUf(val.id).subscribe(data => {
          this.cidadeList = data.sort((a: { nome: string; }, b: { nome: any; }) => a.nome.localeCompare(b.nome));
        });
      } else this.cidadeList = [];
    })

    this.paisControl?.valueChanges.subscribe((val: any) => {
      if (val?.id) {
        // console.log(val)
        this.contatoForm.patchValue({ddi: val?.ddi});
      }
    });

    this.escolherContatoControl?.valueChanges.subscribe((val: any) => {
      if(val) {
        // this.ufService.consultar(val).subscribe((data: any) => {
        //   this.contatoForm.patchValue(data);
        // });
      }
    });

    this.enderecoMunicipioControl?.valueChanges.subscribe((val: any) => {
      if (val) {
        // this.cidadeService.getBairrosByCidade(val.id).subscribe((data: any) => {
        //   this.bairrosList = data.sort((a: { nome: string; }, b: { nome: any; }) => a.nome.localeCompare(b.nome));
        // });
      }
    });
  }

  carregarPais() {
    this.paisService.listar().subscribe((data: any) => {
      this.paisesList = data

      const defaultPais = this.paisesList.find(pais => pais.nome === 'Brasil');

      if (defaultPais) {
        this.contatoForm.patchValue({
          pais: defaultPais
        });
      }
    });
  }

  construirForm() {
    this.contatoForm = this.fb.group({
      id:[''],
      pais: [''],
      enderecoUf: [''],
      enderecoMunicipio: [''],
      enderecoBairro: [''],
      enderecoCep: [''],
      // pais: ['', Validators.required],
      // enderecoUf: ['', Validators.required],
      // enderecoMunicipio: ['', Validators.required],
      // enderecoBairro: ['', Validators.required],
      // enderecoCep: ['', Validators.required],
      enderecoNumero: [''],
      enderecoLogradouro: [''],
      // enderecoLogradouro: ['', Validators.required],
      enderecoComplemento: [''],
      // informacoesAdicionais: ['', Validators.required],
      informacoesAdicionais: [''],
      ddi: [''],
      telefone: ['', CustomValidators.telefone],
      telefoneAdicional: [''],
      ddiFax: [''],
      fax: [''],
      faxAdicional: [''],
      // email: ['', [Validators.email, Validators.pattern('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}')]],
      siteUrl: [''],
      ramal: [''],
      tipoContato: [''],
      flagPrincipal: [false],
      email: [''],
      escolherContato: [''],
      flagContatoDelegado: [false],
      pessoaDelegadaId: [''],
    });

    if(this.paginaEntidade) {
      this.contatoForm.valueChanges.subscribe(() => {
        this.emitirAlteracaoFormulario();
      });
    }
  }

  emitirAlteracaoFormulario() {
    if (this.contatoForm.dirty) {
      this.salvar();
    }
  }

  carregarListas(): void {
    this.paisService.listar().subscribe((ddi: any) => this.ddiList = ddi);
    forkJoin({
      tipoContato: this.tipoContatoService.listar(),
      enderecoUf: this.ufService.listar(),
      pais: this.paisService.listar(),
      nomePessoa : this.paginaEntidade ? of([]) : this.pessoaService.pessoaCombo()

    }).subscribe(({ tipoContato, enderecoUf, pais,nomePessoa }) => {
      this.ufList = enderecoUf.sort((a, b) => a.nome.localeCompare(b.nome));
      this.paisesList = pais;
      this.nomePessoaList = nomePessoa;
      if(this.contato && !this.paginaEntidade) {
        this.tipoContatoList = !this.existeEndereco ? tipoContato : tipoContato.filter((tipoContato: any) => tipoContato.id !== TipoContatoEnum.ENDERECO);
        this.contatoForm.patchValue(this.contato);
      }else{
        this.tipoContatoList = tipoContato;
      }

      const enderecoPrincipal = this.dataSet?.find((item: any) => item.flagPrincipal);
      if (this.paginaEntidade && enderecoPrincipal) {
        this.contatoForm.patchValue(enderecoPrincipal);
        const tipoContatoDefault = tipoContato.filter((tipoContato: any) => tipoContato.id !== TipoContatoEnum.ENDERECO);
        this.contatoForm.get('tipoContato')?.setValue(tipoContatoDefault);
      }

      const defaultPais = this.paisesList.find(pais => pais.nome === 'Brasil');

      if (defaultPais) {
        this.contatoForm.patchValue({
          pais: defaultPais
        });
      }
    });
  }

  reset() {
    this.inserir = true;

    Object.keys(this.contatoForm.controls).forEach(key => {
      const control = this.contatoForm.get(key);
      if (control) {
        control.clearValidators();
        control.updateValueAndValidity({ emitEvent: false });
      }
    });

    this.contatoForm.reset();

    Object.keys(this.contatoForm.controls).forEach(key => {
      const control = this.contatoForm.get(key);
      if (control) {
        switch (key) {
          case 'pais':
          case 'enderecoUf':
          case 'enderecoMunicipio':
          case 'enderecoBairro':
          case 'enderecoCep':
          case 'enderecoLogradouro':
          case 'informacoesAdicionais':
          case 'siteUrl':
          case 'tipoContato':
            control.setValidators(Validators.required);
            break;
          case 'ddi':
            control.setValidators(Validators.pattern(/^\+[1-9]\d{0,2}$/));
            break;
          case 'email':
            control.setValidators([Validators.email, Validators.pattern('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}')]);
            break;
          default:
            // Outros campos não possuem validação
            break;
        }
        control.updateValueAndValidity({ emitEvent: false });
      }
    });
  }

  checkIfPrincipal(event: MouseEvent): void {
    const inputElement = event?.target as HTMLInputElement;

    if (!inputElement || inputElement.checked == null) {
      return;
    }

    const alreadyPrincipal = this.contatos.some(contato =>
      contato.flagPrincipal && contato !== this.contatoEditado
    );

    if (alreadyPrincipal && !this.contatoEditado.flagPrincipal) {
      this.messageService.warning('Já existe um contato marcado como principal. Não é possível marcar outro.');
      inputElement.checked = false;
    } else {
      // console.log('Checkbox is checked:', inputElement.checked);
      this.contatoEditado.flagPrincipal = inputElement.checked;
    }
  }



  onTipoContatoChange(value: any): void {
    if (value !== undefined) {
      this.tipoContatoSelecionada = this.tipoContatoList.find((tipo: any) => tipo?.id === value?.id);
      this.updateFormFields();
    }
  }

  updateFormFields(): void {
    this.resetValidators();

    switch (this.tipoContatoSelecionada?.id && !this.paginaEntidade) {
      case TipoContatoEnum.EMAIL:
        this.setEmailValidators();
        break;

      case TipoContatoEnum.TELEFONE:
        this.setTelefoneValidators();
        break;

      case TipoContatoEnum.ENDERECO:
        this.setEnderecoValidators();
        break;

      default:
        break;
    }

    this.setFormState();
    this.updateFormValidity();
  }

  resetValidators(): void {
    this.contatoForm.get('email')?.clearValidators();
    this.contatoForm.get('telefone')?.clearValidators();
    this.contatoForm.get('pais')?.clearValidators();
    this.contatoForm.get('enderecoUf')?.clearValidators();
    this.contatoForm.get('enderecoMunicipio')?.clearValidators();
    this.contatoForm.get('enderecoBairro')?.clearValidators();
    this.contatoForm.get('enderecoCep')?.clearValidators();
    this.contatoForm.get('enderecoLogradouro')?.clearValidators();
  }

  setEmailValidators(): void {
    this.contatoForm.get('email')?.setValidators([
      Validators.required,
      Validators.email,
      Validators.pattern('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}')
    ]);
  }

  setTelefoneValidators(): void {
    this.contatoForm.get('telefone')?.setValidators([Validators.required]);

    if (this.existeEndereco) {
      const itemEndereco = this.dataSet.find((item: any) => item.tipoContato.id === TipoContatoEnum.ENDERECO);
      if (itemEndereco) {
        const ddiPais = this.ddiList.find((ddi: any) => ddi.id === itemEndereco.pais.id);
        if (ddiPais) {
          this.contatoForm.patchValue({ ddi: ddiPais.ddi });
        }
      }
    }
  }

  setEnderecoValidators(): void {
    this.contatoForm.get('pais')?.setValidators([Validators.required]);
    this.contatoForm.get('enderecoUf')?.setValidators([Validators.required]);
    this.contatoForm.get('enderecoMunicipio')?.setValidators([Validators.required]);
    this.contatoForm.get('enderecoBairro')?.setValidators([Validators.required]);
    this.contatoForm.get('enderecoCep')?.setValidators([Validators.required]);
    this.contatoForm.get('enderecoLogradouro')?.setValidators([Validators.required]);
  }

  updateFormValidity(): void {
    this.contatoForm.get('email')?.updateValueAndValidity();
    this.contatoForm.get('telefone')?.updateValueAndValidity();
    this.contatoForm.get('pais')?.updateValueAndValidity();
    this.contatoForm.get('enderecoUf')?.updateValueAndValidity();
    this.contatoForm.get('enderecoMunicipio')?.updateValueAndValidity();
    this.contatoForm.get('enderecoBairro')?.updateValueAndValidity();
    this.contatoForm.get('enderecoCep')?.updateValueAndValidity();
    this.contatoForm.get('enderecoLogradouro')?.updateValueAndValidity();
  }

  compareFn(a: any, b: any): boolean {
    if (typeof a === 'boolean' && (typeof b === 'string' || typeof b === 'boolean')) {
      b = b === 'true';
    } if (a?.id !== undefined && b?.id !== undefined) {
      return a.id === b.id;
    } else if (a?.codigo !== undefined && b?.codigo !== undefined) {
      return a.codigo === b.codigo;
    } else if (a?.id !== undefined && b !== undefined) {
      return a.id === b;
    } else if (a !== undefined && b?.id !== undefined) {
      return a === b?.id;
    } else if (a?.uf !== undefined && b?.sigla !== undefined) {
      // console.log('a.uf', a.uf);
      return a?.uf === b?.sigla
    } else if (a?.cidade !== undefined && b?.nome !== undefined) {
      // console.log('a.cidade', a.cidade);
      // console.log('b.nome', b.nome);
      return a?.cidade === b?.nome && a?.uf === b?.uf.sigla
    } else {
      return a === b;
    }
  }

  setFormState(): void {
    if (this.visualizar) {
      this.contatoForm.disable();
    }
  }

  salvar(): void {
    const flagPrincipal = this.contatoForm.get('flagPrincipal')?.value;
    if (flagPrincipal && this.dataSet.some((contact: { flagPrincipal: any; id: any; }) => contact.flagPrincipal
      && contact.id !== this.contatoForm.get('id')?.value)) {
      alert('Já existe um contato principal.');
    } else {
      if(this.contatoForm.valid) {
        let objEnvio = { ...this.contatoForm.getRawValue() };

        if(this.paginaEntidade) {
          objEnvio.flagPrincipal = true;
        }

        this.contatoEmit.emit(objEnvio);

        if(!this.paginaEntidade) {
          this.reset();
        }
      }
      // else {
      //   // console.log(this.contatoForm.value)
      //   this.messageService.error('Preencha os campos obrigatórios');
      // }
    }
  }

  onCepBlur(): void {
    const cep = this.contatoForm.get('enderecoCep')?.value;
    if (cep) {
      this.fetchCepData(cep);
    }
  }

  fetchCepData(cep: string): void {
    this.cepService.buscarEndereco(cep).subscribe(
      (data: any) => {
        if (!data.erro) {
          // console.log('CEP encontrado', data);

          // Encontrar a UF correspondente na lista de UFs
          const ufSelecionada = this.ufList.find(uf => uf.sigla === data.uf);
           // console.log('ufSelecionada', ufSelecionada);
          if (ufSelecionada && (!this.enderecoUf?.value || this.enderecoUf?.value.id !== ufSelecionada.id)) {
            this.enderecoUf?.patchValue(ufSelecionada); // Atualiza o valor do select de UF
            this.cidadeService.getCidadesByUf(ufSelecionada.id).subscribe(cidades => {
              this.cidadeList = cidades.sort((a: { nome: string; }, b: { nome: any; }) => a.nome.localeCompare(b.nome));
              this.setMunicipio(data); // Chamada para configurar a cidade após a atualização
            });
          } else {
            this.setMunicipio(data); // Caso a UF já esteja selecionada
          }

          this.contatoForm.patchValue({
            enderecoLogradouro: data.logradouro,
            enderecoBairro: data.bairro,
          });
        } else {
          console.error('CEP não encontrado');
        }
      },
      (error) => {
        console.error('Erro ao buscar o CEP', error);
      }
    );
  }

  setMunicipio(data: any): void {
    const municipioSelecionado = this.cidadeList.find(cidade =>
      cidade.nome === data.cidade && cidade.uf.sigla === data.uf
    );

    this.contatoForm.patchValue({
      enderecoMunicipio: municipioSelecionado || null,
      enderecoUf: municipioSelecionado?.uf || null,
    });
  }

    checkIfDelegado(event: boolean): void {
    this.showPessoaDelegada = event;
  }

  tamanhoControl(value: string, form: FormGroup, input: string, tamanho: number): void {
    if (!form || !value) {
      return;
    }

    const maxLength = tamanho;
    if (value.length > maxLength) {
      const truncatedValue = value.slice(0, maxLength);
      const control = form.get(input);
      if (control) {
        control.setValue(truncatedValue, { emitEvent: false });
        control.markAsDirty();
        control.updateValueAndValidity();
      }
    }
  }

  get paisControl() {
    return this.contatoForm.get('pais');
  }

  get tipoContatoId() {
    return this.contatoForm.get('tipoContato')?.value?.id;
  }

  get enderecoUf() {
    return this.contatoForm.get('enderecoUf');
  }

  get escolherContatoControl() {
    return this.contatoForm.get('escolherContato');
  }

  get enderecoMunicipioControl() {
    return this.contatoForm.get('enderecoMunicipio');
  }
}
